import { useState } from "react";
import { Megaphone } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function AppealButton({ svc, onSent }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!window.confirm(`Inviare un appello ai volontari che possono coprire i posti mancanti di «${svc.event_name}»?\nRiceveranno notifica in app, push ed email.`)) return;
    setBusy(true);
    try {
      const r = await api.post(`/services/${svc.id}/appeal`);
      toast.success(r.data.sent ? `Appello inviato a ${r.data.sent} volontari` : "Nessun volontario disponibile con le qualifiche richieste");
      onSent && onSent();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Invio non riuscito");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button size="sm" variant="ghost" title="Appello ai disponibili" data-testid={`appeal-service-${svc.id}`} disabled={busy} onClick={send} className="hover:bg-muted text-amber-700">
      <Megaphone className="h-4 w-4" />
    </Button>
  );
}
